// Key is a page path (main page, not a tab),
// Value is an array of functions that has to be allowed to show page in the main menu.
export var menuRestrictions = {
  schedule: [],
  forecast: [],
  exchange: [],
  reports: [],
  timetable: [
    /*
    'get_worker_day',
    'get_worker_day_logs',
    'get_cashiers_list',
    'get_cashier_timetable',
    'get_outsource_workers',
    'get_month_stat'
    */
  ],
  auto: [],
  notifications: ['get_notifications'],
  settings: [],
  faq: []
};